// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
export class LineGroup extends PFixFieldSet {
    constructor(fields) {
        super(FieldsFactory.LINE_GROUP_NAME, null, fields);
    }
    getContent() {
        return this.GetValue(FieldsFactory.FIELD_TEXT);
    }
    setContent(content) {
        this.SetField(FieldsFactory.FIELD_TEXT, content);
    }
    getLineNum() {
        return this.GetValue(FieldsFactory.FIELD_LINE_NUMBER);
    }
    setLineNum(lineNumber) {
        this.SetField(FieldsFactory.FIELD_LINE_NUMBER, lineNumber);
    }
    static setLongText(text) {
        const groups = [];
        let number = 0;
        let index = 0;
        const length = text.length;
        while (index < length) {
            const len = Math.min(length - index, this.MAX_LENGTH);
            const curString = text.substring(index, index + len);
            index += len;
            const group = new LineGroup();
            group.setContent(curString);
            group.setLineNum(number);
            groups[number] = group;
            number += 1;
        }
        return groups;
    }
    static CompareTo(a, b) {
        const an = a.getLineNum();
        const bn = b.getLineNum();
        if (an < bn) {
            return -1;
        }
        else if (an > bn) {
            return 1;
        }
        else {
            return 0;
        }
    }
    static getLongText(fieldSet) {
        const groups = fieldSet.GetGroups(FieldsFactory.LINE_GROUP_NAME);
        const lines = [];
        let i;
        const count = groups.length;
        for (i = 0; i < count; i++) {
            lines[i] = new LineGroup(groups[i]);
        }
        lines.sort(this.CompareTo);
        let sb = '';
        for (i = 0; i < count; i++) {
            sb += lines[i].getContent();
        }
        return sb;
    }
}
LineGroup.MAX_LENGTH = 10000;
